import React, { useEffect, useRef } from 'react';
import * as am4charts from '@amcharts/amcharts4/charts';
import styled from 'styled-components';
import { Series, setupChart } from './am4charts';
import { useClickStreamContext } from 'features/shared/ClickStream';

const AxisTitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: rgba(9, 21, 38, 0.6);
`;

interface Props {
  yTitle: React.ReactNode;
  showTotal?: boolean;
  series: Series[];
}

const Component = ({ yTitle, showTotal, series }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const chart = useRef<am4charts.XYChart>();
  const { logPageEvent } = useClickStreamContext();

  useEffect(() => {
    if (chart.current) {
      chart.current.dispose();
      chart.current = undefined;
    }
    chart.current = setupChart(ref.current!, series, showTotal);
    const handleClick = () => {
      logPageEvent({
        eventType: 'schools_statistic_by_month_click_on_chart_legend',
        eventInfo: 'Школы|Статистика по месяцам: Клик по легенде графика',
      });
    };
    chart.current.legend.dom.addEventListener('click', handleClick);

    return () => {
      chart.current?.legend?.dom?.removeEventListener('click', handleClick);
      chart.current!.dispose();
    };
  }, [showTotal, series]);

  return (
    <>
      <AxisTitle>{yTitle}</AxisTitle>
      <div ref={ref} style={{ width: '100%', height: '397px' }} />
    </>
  );
};

export default Component;
